export default {"src":"/_next/static/media/coffee-shop.2bac280e.svg","height":77,"width":76,"blurWidth":0,"blurHeight":0};